// Auto-generated timestamp-based version suffix
const buildTimestamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0];

export const VERSION = {
  MAJOR: 1,
  MINOR: 2,
  BUILD: buildTimestamp,
  toString: function() {
    return `v${this.MAJOR}.${this.MINOR}.${this.BUILD}`;
  }
};
